module.exports = __webpack_public_path__ + "static/media/eco-ecology-industry-svgrepo-com.5740809d.svg";